export default "__VITE_ASSET__CEbvbbB4__"